<div class="tab-content">
  <div class="tab-header-row">
    <h2>Customer Samples</h2>
    <button mat-button class="btn-bg-green" [disabled]="!canEdit" (click)="openSampleForm()">Request Sample</button>
  </div>

  <rms-table [data]="Samples" [columns]="Columns"></rms-table>
</div>
